//
//
//
//
//
//
//
import ScreenOrientation from '@tencent/vft-ui/src/ScreenOrientation';
import env from '@tencent/vft-common/env'; // import { setTitle } from './util/helper'

import Index from './components/Index.vue';
export default {
  components: {
    ScreenOrientation: ScreenOrientation,
    Index: Index
  },
  computed: {
    isPad: function isPad() {
      return env.isIpad || env.isApad;
    }
  },
  methods: {
    checkEndTime: function checkEndTime() {
      var 活动截止时间 = this.setting.活动截止时间;

      if (this.now > 活动截止时间) {
        this.alert({
          msg: '活动已经结束啦',
          confirmText: '前往福利社',
          confirm: function confirm() {
            window.location.href = 'https://film.qq.com/x/welfare/';
          }
        });
      }
    }
  },
  mounted: function mounted() {
    // const {
    //   页面标题,
    // } = this.setting.默认分享
    // setTitle(页面标题)
    this.initShareInfo(this.setting.默认分享, this.userService);
    this.checkEndTime();
  }
};